import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISiteNameSansId } from '../types/ISiteNameSansId';

export interface IGetSiteNamesAcrossAllPodsResult extends IGetItemsResult {
  siteNames: ISiteNameSansId[];
}

export class GetSiteNamesAcrossAllPodsRequest extends Request<IGetItemsParams, IGetSiteNamesAcrossAllPodsResult> {
  constructor(params: IGetItemsParams) {
    super('getSiteNamesAcrossAllPods', params);
  }
}
